import * as __SNOWPACK_ENV__ from '../../../_snowpack/env.js';

import './JewelleryDetailCartIn.svelte.css';
/* src/components/JewelleryDetail/JewelleryDetailCartIn.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	append,
	attr,
	destroy_each,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	safe_not_equal,
	set_data,
	space,
	src_url_equal,
	text
} from "../../../_snowpack/pkg/svelte/internal.js";

import { onMount } from '../../../_snowpack/pkg/svelte.js';

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[8] = list[i];
	child_ctx[10] = i;
	return child_ctx;
}

// (59:3) {:else}
function create_else_block_1(ctx) {
	let t0;
	let select;
	let t1;
	let a;
	let t2;
	let mounted;
	let dispose;
	let each_value = /*jewellery*/ ctx[0].sizeList;
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			t0 = text("サイズ：\n\t\t\t\t");
			select = element("select");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t1 = space();
			a = element("a");
			t2 = text("サイズの測り方");
			attr(select, "name", "size_id");
			attr(a, "href", /*sizeLink*/ ctx[4]);
		},
		m(target, anchor) {
			insert(target, t0, anchor);
			insert(target, select, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(select, null);
			}

			insert(target, t1, anchor);
			insert(target, a, anchor);
			append(a, t2);

			if (!mounted) {
				dispose = listen(select, "change", /*changeSizeItem*/ ctx[5]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty & /*isSelected, jewellery*/ 65) {
				each_value = /*jewellery*/ ctx[0].sizeList;
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(select, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}
		},
		d(detaching) {
			if (detaching) detach(t0);
			if (detaching) detach(select);
			destroy_each(each_blocks, detaching);
			if (detaching) detach(t1);
			if (detaching) detach(a);
			mounted = false;
			dispose();
		}
	};
}

// (57:3) {#if !('1' === jewellery.typeID)}
function create_if_block_1(ctx) {
	let input;
	let input_value_value;

	return {
		c() {
			input = element("input");
			attr(input, "type", "hidden");
			attr(input, "name", "size_id");
			input.value = input_value_value = /*jewellery*/ ctx[0].defaultSizeID;
		},
		m(target, anchor) {
			insert(target, input, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*jewellery*/ 1 && input_value_value !== (input_value_value = /*jewellery*/ ctx[0].defaultSizeID)) {
				input.value = input_value_value;
			}
		},
		d(detaching) {
			if (detaching) detach(input);
		}
	};
}

// (62:5) {#each jewellery.sizeList as size, key}
function create_each_block(ctx) {
	let option;
	let t0_value = /*size*/ ctx[8].name + "";
	let t0;
	let t1;
	let option_value_value;
	let option_selected_value;

	return {
		c() {
			option = element("option");
			t0 = text(t0_value);
			t1 = space();
			option.__value = option_value_value = /*key*/ ctx[10] + 1;
			option.value = option.__value;
			option.selected = option_selected_value = /*isSelected*/ ctx[6](/*key*/ ctx[10]) ? 'selected' : '';
		},
		m(target, anchor) {
			insert(target, option, anchor);
			append(option, t0);
			append(option, t1);
		},
		p(ctx, dirty) {
			if (dirty & /*jewellery*/ 1 && t0_value !== (t0_value = /*size*/ ctx[8].name + "")) set_data(t0, t0_value);
		},
		d(detaching) {
			if (detaching) detach(option);
		}
	};
}

// (81:4) {:else}
function create_else_block(ctx) {
	let button;

	return {
		c() {
			button = element("button");
			button.textContent = "入荷待ちの商品を予約する";
			attr(button, "type", "submit");
			attr(button, "name", "add-to-cart");
			button.value = "8606";
			attr(button, "class", "lit-gradient-button gradient-orange svelte-ped14s");
		},
		m(target, anchor) {
			insert(target, button, anchor);
		},
		d(detaching) {
			if (detaching) detach(button);
		}
	};
}

// (74:4) {#if !currentSizeItem.yoyaku}
function create_if_block(ctx) {
	let button;

	return {
		c() {
			button = element("button");
			button.textContent = "カートに入れる";
			attr(button, "type", "submit");
			attr(button, "name", "add-to-cart");
			button.value = "8606";
			attr(button, "class", "lit-gradient-button svelte-ped14s");
		},
		m(target, anchor) {
			insert(target, button, anchor);
		},
		d(detaching) {
			if (detaching) detach(button);
		}
	};
}

function create_fragment(ctx) {
	let meta_1;
	let meta_1_content_value;
	let t0;
	let div1;
	let h3;
	let img;
	let img_src_value;
	let t1;
	let form;
	let input0;
	let input0_value_value;
	let t2;
	let input1;
	let t3;
	let p0;
	let em0;
	let t4;
	let t5_value = /*currentSizeItem*/ ctx[1].price + "";
	let t5;
	let t6;
	let t7;
	let t8;
	let p1;
	let t9;
	let em1;
	let t10;
	let t11_value = /*currentSizeItem*/ ctx[1].totalPrice + "";
	let t11;
	let t12;
	let t13;
	let div0;
	let t14;
	let fieldset;

	function select_block_type(ctx, dirty) {
		if (!('1' === /*jewellery*/ ctx[0].typeID)) return create_if_block_1;
		return create_else_block_1;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block0 = current_block_type(ctx);

	function select_block_type_1(ctx, dirty) {
		if (!/*currentSizeItem*/ ctx[1].yoyaku) return create_if_block;
		return create_else_block;
	}

	let current_block_type_1 = select_block_type_1(ctx, -1);
	let if_block1 = current_block_type_1(ctx);

	return {
		c() {
			meta_1 = element("meta");
			t0 = space();
			div1 = element("div");
			h3 = element("h3");
			img = element("img");
			t1 = space();
			form = element("form");
			input0 = element("input");
			t2 = space();
			input1 = element("input");
			t3 = space();
			p0 = element("p");
			em0 = element("em");
			t4 = text("￥");
			t5 = text(t5_value);
			t6 = text("(税込)");
			t7 = text("の30%OFF");
			t8 = space();
			p1 = element("p");
			t9 = text("価格： オープン記念価格");
			em1 = element("em");
			t10 = text("￥");
			t11 = text(t11_value);
			t12 = text("(税込)");
			t13 = space();
			div0 = element("div");
			if_block0.c();
			t14 = space();
			fieldset = element("fieldset");
			if_block1.c();
			attr(meta_1, "name", "description");
			attr(meta_1, "content", meta_1_content_value = "商品名:" + /*jewellery*/ ctx[0].postTitle + ", " + /*item_variant*/ ctx[2] + " 価格: " + /*currentSizeItem*/ ctx[1].totalPrice + "円, この" + /*jewellery*/ ctx[0].typeName + "をカスタマイズできます。, カテゴリー: オーダーメイドアクセサリー, 商品コード: " + /*jewellery*/ ctx[0].code);
			if (!src_url_equal(img.src, img_src_value = "" + (/*jewellery*/ ctx[0].assetsUrl + "/common/h3_itempage_cartbox.webp"))) attr(img, "src", img_src_value);
			attr(img, "width", "264");
			attr(img, "height", "15");
			attr(img, "alt", "カスタマイズせず、そのままご購入の方はこちらへ。");
			attr(img, "loading", "lazy");
			attr(h3, "class", "svelte-ped14s");
			attr(input0, "type", "hidden");
			attr(input0, "name", "item_code");
			input0.value = input0_value_value = /*jewellery*/ ctx[0].code;
			attr(input1, "type", "hidden");
			attr(input1, "name", "litAction");
			input1.value = "cart_in";
			attr(em0, "class", "svelte-ped14s");
			attr(p0, "class", "price-off svelte-ped14s");
			attr(em1, "class", "svelte-ped14s");
			attr(p1, "class", "price-sale svelte-ped14s");
			attr(fieldset, "class", "cart-button svelte-ped14s");
			attr(div0, "class", "lit_size_select");
			attr(form, "method", "post");
			attr(form, "action", /*formAction*/ ctx[3]);
			attr(div1, "class", "jewellery-cart-in svelte-ped14s");
		},
		m(target, anchor) {
			append(document.head, meta_1);
			insert(target, t0, anchor);
			insert(target, div1, anchor);
			append(div1, h3);
			append(h3, img);
			append(div1, t1);
			append(div1, form);
			append(form, input0);
			append(form, t2);
			append(form, input1);
			append(form, t3);
			append(form, p0);
			append(p0, em0);
			append(em0, t4);
			append(em0, t5);
			append(em0, t6);
			append(p0, t7);
			append(form, t8);
			append(form, p1);
			append(p1, t9);
			append(p1, em1);
			append(em1, t10);
			append(em1, t11);
			append(em1, t12);
			append(form, t13);
			append(form, div0);
			if_block0.m(div0, null);
			append(div0, t14);
			append(div0, fieldset);
			if_block1.m(fieldset, null);
		},
		p(ctx, [dirty]) {
			if (dirty & /*jewellery, item_variant, currentSizeItem*/ 7 && meta_1_content_value !== (meta_1_content_value = "商品名:" + /*jewellery*/ ctx[0].postTitle + ", " + /*item_variant*/ ctx[2] + " 価格: " + /*currentSizeItem*/ ctx[1].totalPrice + "円, この" + /*jewellery*/ ctx[0].typeName + "をカスタマイズできます。, カテゴリー: オーダーメイドアクセサリー, 商品コード: " + /*jewellery*/ ctx[0].code)) {
				attr(meta_1, "content", meta_1_content_value);
			}

			if (dirty & /*jewellery*/ 1 && !src_url_equal(img.src, img_src_value = "" + (/*jewellery*/ ctx[0].assetsUrl + "/common/h3_itempage_cartbox.webp"))) {
				attr(img, "src", img_src_value);
			}

			if (dirty & /*jewellery*/ 1 && input0_value_value !== (input0_value_value = /*jewellery*/ ctx[0].code)) {
				input0.value = input0_value_value;
			}

			if (dirty & /*currentSizeItem*/ 2 && t5_value !== (t5_value = /*currentSizeItem*/ ctx[1].price + "")) set_data(t5, t5_value);
			if (dirty & /*currentSizeItem*/ 2 && t11_value !== (t11_value = /*currentSizeItem*/ ctx[1].totalPrice + "")) set_data(t11, t11_value);

			if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block0) {
				if_block0.p(ctx, dirty);
			} else {
				if_block0.d(1);
				if_block0 = current_block_type(ctx);

				if (if_block0) {
					if_block0.c();
					if_block0.m(div0, t14);
				}
			}

			if (current_block_type_1 !== (current_block_type_1 = select_block_type_1(ctx, dirty))) {
				if_block1.d(1);
				if_block1 = current_block_type_1(ctx);

				if (if_block1) {
					if_block1.c();
					if_block1.m(fieldset, null);
				}
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			detach(meta_1);
			if (detaching) detach(t0);
			if (detaching) detach(div1);
			if_block0.d();
			if_block1.d();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { jewellery } = $$props;
	let currentSizeItem = {};

	let currentSizeID = jewellery.sizeList[jewellery.defaultSizeID]
	? jewellery.defaultSizeID
	: 1;

	let item_variant = '';
	const formAction = __SNOWPACK_ENV__.SNOWPACK_PUBLIC_API_URL + '/cart/';
	const sizeLink = __SNOWPACK_ENV__.SNOWPACK_PUBLIC_API_URL + '/size_info_accessory/';

	const changeSizeItem = e => {
		$$invalidate(1, currentSizeItem = jewellery.sizeList[e.target.value - 1]);
	};

	const isSelected = id => {
		return currentSizeID === Number(id) + 1 ? true : false;
	};

	onMount(() => {
		$$invalidate(1, currentSizeItem = jewellery.sizeList[jewellery.defaultSizeID - 1] ?? jewellery.sizeList[0]);

		if ('1' === jewellery.typeID) {
			$$invalidate(2, item_variant = ' サイズ: ' + currentSizeItem.name + ',');
		}
	});

	$$self.$$set = $$props => {
		if ('jewellery' in $$props) $$invalidate(0, jewellery = $$props.jewellery);
	};

	return [
		jewellery,
		currentSizeItem,
		item_variant,
		formAction,
		sizeLink,
		changeSizeItem,
		isSelected
	];
}

class JewelleryDetailCartIn extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { jewellery: 0 });
	}
}

export default JewelleryDetailCartIn;